import React from "react";
import { ArrowRight } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { CASE_STUDIES } from "@/lib/site";

export default function CaseStudies() {
  return (
    <>
      <SEO title="Case Studies" description="Case studies from medical, government, industrial, education, commercial, and food service facilities." path="/case-studies" />
      <PageHero
        eyebrow="Case Studies"
        title="Outcomes, not adjectives."
        subtitle="Six real engagements — the challenge we inherited, the program we deployed, and the numbers that resulted."
        image="https://images.pexels.com/photos/8273515/pexels-photo-8273515.jpeg"
        testId="case-studies-hero"
      />

      <section className="es-section bg-white">
        <div className="es-container space-y-10">
          {CASE_STUDIES.map((c, i) => (
            <article key={c.slug} data-testid={`case-study-${c.slug}`} className="grid lg:grid-cols-12 gap-8 items-stretch border border-[var(--es-border)] bg-white rounded-sm overflow-hidden">
              <div className={`lg:col-span-5 ${i % 2 ? "lg:order-2" : ""}`}>
                <img src={c.image} alt={c.title} className="w-full h-full min-h-[280px] object-cover" />
              </div>
              <div className="lg:col-span-7 p-8 md:p-10 flex flex-col">
                <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--es-accent)]">{c.sector}</div>
                <h2 className="mt-2 text-2xl md:text-3xl font-bold text-[var(--es-navy)] leading-tight" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>{c.title}</h2>

                <div className="mt-6 grid sm:grid-cols-3 gap-5">
                  {[
                    { label: "Challenge", text: c.challenge },
                    { label: "Solution", text: c.solution },
                    { label: "Result", text: c.result },
                  ].map((b) => (
                    <div key={b.label}>
                      <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[var(--es-text-muted)] mb-2 border-t-2 border-[var(--es-accent)] pt-2 inline-block">{b.label}</div>
                      <div className="text-sm text-[var(--es-text)] leading-relaxed">{b.text}</div>
                    </div>
                  ))}
                </div>

                <a href="/quote" className="mt-7 self-start es-btn-outline text-sm !py-2.5">
                  Discuss a similar program <ArrowRight size={16} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
}
